import "../CSS/angebot.css";
import { Link } from "react-router-dom";

function AngebotePage() {
    return (
        <>
            <div className="intro">

                <h1>
                    Angebote und Preise
                </h1>

                <p>
                    Tantramassage und achtsames Kuscheln bei
                    IRJ-Tantramassagen im Sarganserland.
                </p>

            </div>

            <main className="angebot-inhalt">

                <div className="angebot-auswahl">

                    <Link
                        className="angebot-button"
                        to="/tantramassage"
                    >
                        Tantramassage
                    </Link>

                    <Link
                        className="angebot-button"
                        to="/kuscheln"
                    >
                        Kuscheln
                    </Link>

                </div>


                <p>
                    Egal für welches Angebot Du Dich entscheidest, werden wir
                    uns vor Beginn der Massage oder des Kuschelns über Deine
                    Bedürfnisse und Deine und meine Grenzen in einem
                    Vorgespräch unterhalten und diese festlegen.
                </p>

                <p>
                    Somit ist der achtsame Umgang und Rahmen definiert und
                    wir können uns ganz auf die gemeinsame Zeit einlassen.
                </p>

                <p>
                    Die unten angegebenen Zeiten sind reine Massagezeiten.
                    Rechne bitte für die Gesamtzeit sicher 30-45 Minuten dazu
                    für Gespräch und Umziehen/Duschen.
                </p>

                <p>
                    Um das Tantramassage-Ritual in seiner Vollständigkeit
                    auszuführen braucht es 2 - 2.5 Stunden Zeit.
                    Für alle mit weniger Zeit biete ich auch 90 Minuten an.
                    Beachte aber bitte, dass hier nicht das komplette Ritual
                    seinen Raum findet.
                </p>


                <section className="angebot-preise">

                    <h2>
                        Preise
                    </h2>

                    <p>
                        Auf alle angegebenen Preise gewähre ich aktuell
                        einen Einführungsrabatt von 50 %.
                    </p>

                    <table className="preis-tabelle">

                        <thead>
                            <tr>
                                <th>Dauer</th>
                                <th>Preis</th>
                            </tr>
                        </thead>

                        <tbody>

                            <tr>
                                <td>90 Minuten</td>
                                <td>300.– CHF</td>
                            </tr>

                            <tr>
                                <td>2 Stunden</td>
                                <td>350.– CHF</td>
                            </tr>

                            <tr>
                                <td>2,5 Stunden</td>
                                <td>380.– CHF</td>
                            </tr>

                            <tr>
                                <td>3 Stunden</td>
                                <td>420.– CHF</td>
                            </tr>

                        </tbody>

                    </table>

                </section>

            </main>
        </>
    );
}

export default AngebotePage;